import _ from 'underscore';
import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

import _t from 'i18n!nls/discussions';

const SERIALIZED_PROPS = [
  'selectedSession',
  'onDemandSelected',
  'showAll',
  'allSessions',
  'courseBranches',
  'sessionsLoaded',
  'currentBranchId',
  'onDemandBranchId',
  'currentSessionId',
  'initialBranchId',
];

class SessionFilterStore extends BaseStore {
  static storeName = 'SessionFilterStore';

  loadSessionsHelper({ sessions, courseBranches, courseId, currentSessionId }: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseBranches' does not exist on type '... Remove this comment to see the full error message
    this.courseBranches = courseBranches;

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseBranches' does not exist on type '... Remove this comment to see the full error message
    if (!this.courseBranches || this.courseBranches.length === 0) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseBranches' does not exist on type '... Remove this comment to see the full error message
      this.courseBranches = [
        {
          id: courseId,
          authoringName: _t('Original Version'),
        },
      ];
    }

    // if the session does not have a branchId, it is the courseId (default branch)
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'allSessions' does not exist on type 'Ses... Remove this comment to see the full error message
    this.allSessions = sessions
      ? sessions.map((session: $TSFixMe) => {
          if (session.branchId) {
            return session;
          }
          return Object.assign(session, { branchId: courseId });
        })
      : [];

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDemandBranchId' does not exist on type... Remove this comment to see the full error message
    this.onDemandBranchId = courseId;

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'allSessions' does not exist on type 'Ses... Remove this comment to see the full error message
    const currentSession = this.allSessions.find((session) => session.id === currentSessionId);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentSessionId' does not exist on type... Remove this comment to see the full error message
    this.currentSessionId = currentSessionId;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentBranchId' does not exist on type ... Remove this comment to see the full error message
    this.currentBranchId = currentSession ? currentSession.branchId : courseId;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'initialBranchId' does not exist on type ... Remove this comment to see the full error message
    this.initialBranchId = this.currentBranchId;

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sessionsLoaded' does not exist on type '... Remove this comment to see the full error message
    this.sessionsLoaded = true;
  }

  static handlers = {
    LOAD_SESSIONS_DATA(payload: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'loadSessionsHelper' does not exist on ty... Remove this comment to see the full error message
      this.loadSessionsHelper(payload);

      // start in all sessions
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'showAll' does not exist on type '{ LOAD_... Remove this comment to see the full error message
      this.showAll = true;

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ LO... Remove this comment to see the full error message
      this.emitChange();
    },

    LOAD_SESSIONS_DATA_UNPRIVILEGED(payload: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'loadSessionsHelper' does not exist on ty... Remove this comment to see the full error message
      this.loadSessionsHelper(payload);

      if (!payload.isPrivateSession) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'showAll' does not exist on type '{ LOAD_... Remove this comment to see the full error message
        this.showAll = true;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentSessionId' does not exist on type... Remove this comment to see the full error message
      } else if (this.currentSessionId) {
        // @ts-expect-error ts-migrate(2551) FIXME: Property 'selectedSession' does not exist on type ... Remove this comment to see the full error message
        this.selectedSession = this.currentSessionId;
      } else {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDemandSelected' does not exist on type... Remove this comment to see the full error message
        this.onDemandSelected = true;
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ LO... Remove this comment to see the full error message
      this.emitChange();
    },

    SELECT_SESSION({ sessionId }: $TSFixMe) {
      // @ts-expect-error ts-migrate(2551) FIXME: Property 'selectedSession' does not exist on type ... Remove this comment to see the full error message
      this.selectedSession = sessionId;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDemandSelected' does not exist on type... Remove this comment to see the full error message
      this.onDemandSelected = false;

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'allSessions' does not exist on type '{ L... Remove this comment to see the full error message
      const session = this.allSessions.find((potentialSesssion) => potentialSesssion.id === sessionId);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentBranchId' does not exist on type ... Remove this comment to see the full error message
      this.currentBranchId = session && session.branchId;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'showAll' does not exist on type '{ LOAD_... Remove this comment to see the full error message
      this.showAll = false;

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ LO... Remove this comment to see the full error message
      this.emitChange();
    },

    SELECT_ON_DEMAND() {
      // @ts-expect-error ts-migrate(2551) FIXME: Property 'selectedSession' does not exist on type ... Remove this comment to see the full error message
      this.selectedSession = null;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDemandSelected' does not exist on type... Remove this comment to see the full error message
      this.onDemandSelected = true;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentBranchId' does not exist on type ... Remove this comment to see the full error message
      this.currentBranchId = this.onDemandBranchId;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'showAll' does not exist on type '{ LOAD_... Remove this comment to see the full error message
      this.showAll = false;

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ LO... Remove this comment to see the full error message
      this.emitChange();
    },

    SELECT_SHOW_ALL({ branchId }: $TSFixMe) {
      // @ts-expect-error ts-migrate(2551) FIXME: Property 'selectedSession' does not exist on type ... Remove this comment to see the full error message
      this.selectedSession = null;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDemandSelected' does not exist on type... Remove this comment to see the full error message
      this.onDemandSelected = false;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'showAll' does not exist on type '{ LOAD_... Remove this comment to see the full error message
      this.showAll = true;

      if (branchId) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentBranchId' does not exist on type ... Remove this comment to see the full error message
        this.currentBranchId = branchId;
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ LO... Remove this comment to see the full error message
      this.emitChange();
    },
  };

  constructor(dispatcher: $TSFixMe) {
    super(dispatcher);

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSession' does not exist on type ... Remove this comment to see the full error message
    this.selectedSession = null;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDemandSelected' does not exist on type... Remove this comment to see the full error message
    this.onDemandSelected = false;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'showAll' does not exist on type 'Session... Remove this comment to see the full error message
    this.showAll = false;

    // Store all sessions here as well. Usually we dont expose
    // all sessions to users so we should store the options here.
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'allSessions' does not exist on type 'Ses... Remove this comment to see the full error message
    this.allSessions = [];
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseBranches' does not exist on type '... Remove this comment to see the full error message
    this.courseBranches = [];
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sessionsLoaded' does not exist on type '... Remove this comment to see the full error message
    this.sessionsLoaded = false;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentBranchId' does not exist on type ... Remove this comment to see the full error message
    this.currentBranchId = null;
  }

  dehydrate() {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    return _(this).pick(...SERIALIZED_PROPS);
  }

  rehydrate(state: $TSFixMe) {
    Object.assign(this, _(state).pick(...SERIALIZED_PROPS));
  }

  get activeFilter() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSession' does not exist on type ... Remove this comment to see the full error message
    if (this.selectedSession) {
      return (
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'allSessions' does not exist on type 'Ses... Remove this comment to see the full error message
        this.allSessions
          .map((session: $TSFixMe) => ({
            id: session.id,
            branchId: session.branchId,
            startedAt: session.startedAt,
            endedAt: session.endedAt,
          }))
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSession' does not exist on type ... Remove this comment to see the full error message
          .find((session) => session.id === this.selectedSession)
      );
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDemandSelected' does not exist on type... Remove this comment to see the full error message
    } else if (this.onDemandSelected) {
      return {
        id: 'ondemand',
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDemandBranchId' does not exist on type... Remove this comment to see the full error message
        branchId: this.onDemandBranchId,
        startedAt: null,
        endedAt: null,
      };
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'showAll' does not exist on type 'Session... Remove this comment to see the full error message
    } else if (this.showAll) {
      return {
        id: 'all',
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentBranchId' does not exist on type ... Remove this comment to see the full error message
        branchId: this.currentBranchId,
        startedAt: null,
        endedAt: null,
      };
    } else {
      return null;
    }
  }

  get activeFilterQueryString() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSession' does not exist on type ... Remove this comment to see the full error message
    if (this.selectedSession) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSession' does not exist on type ... Remove this comment to see the full error message
      return `session~${this.selectedSession}`;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDemandSelected' does not exist on type... Remove this comment to see the full error message
    } else if (this.onDemandSelected) {
      return 'ondemand';
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'showAll' does not exist on type 'Session... Remove this comment to see the full error message
    } else if (this.showAll) {
      return 'all';
    } else {
      return null;
    }
  }

  get filters() {
    // Add ondemand for courses with ondemand sessions
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'allSessions' does not exist on type 'Ses... Remove this comment to see the full error message
    const filters = _(this.allSessions)
      .chain()
      .sortBy((session) => session.startedAt * -1)
      .value()
      .map((session) => {
        return {
          id: session.id,
          branchId: session.branchId,
          startedAt: session.startedAt,
          endedAt: session.endedAt,
        };
      })
      .concat([
        {
          id: 'ondemand',
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDemandBranchId' does not exist on type... Remove this comment to see the full error message
          branchId: this.onDemandBranchId,
          startedAt: null,
          endedAt: null,
        },
      ]);

    return filters;
  }

  get filtersLoaded() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sessionsLoaded' does not exist on type '... Remove this comment to see the full error message
    return this.sessionsLoaded;
  }

  getFiltersForBranch(branchId: $TSFixMe) {
    // always show the 'all' label, but update it with the branchId that we want.
    return this.filters
      .filter((session) => session.branchId === branchId)
      .concat([
        {
          id: 'all',
          startedAt: null,
          endedAt: null,
          branchId,
        },
      ]);
  }

  get branches() {
    const filters = this.filters;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseBranches' does not exist on type '... Remove this comment to see the full error message
    return this.courseBranches.map((branch) => {
      return {
        id: branch.id,
        label: branch.authoringName,
        filters: filters
          .filter((filter) => filter.branchId === branch.id)
          .concat({
            id: 'all',
            startedAt: null,
            endedAt: null,
            branchId: branch.id,
          }),
      };
    });
  }

  get overrideBranchId() {
    // if we are in the users default branch, we don't need the branch filter.
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'initialBranchId' does not exist on type ... Remove this comment to see the full error message
    if (this.initialBranchId === this.currentBranchId) {
      return null;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentBranchId' does not exist on type ... Remove this comment to see the full error message
    return this.currentBranchId;
  }

  get containsMultipleBranches() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseBranches' does not exist on type '... Remove this comment to see the full error message
    return this.courseBranches && this.courseBranches.length > 1;
  }

  getSelectedSessionId() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSession' does not exist on type ... Remove this comment to see the full error message
    return this.selectedSession;
  }
}

export default SessionFilterStore;
